export enum POStatus {
    DRAFT = "DRAFT", 
    SUBMITTED = "SUBMITTED", 
    APPROVED = "APPROVED", 
    REJECTED = "REJECTED", 
    CANCELLED = "CANCELLED", 
    COMPLETED = "COMPLETED", 
    CLOSED = "CLOSED", 
    IN_PROGRESS = "IN_PROGRESS", 
  }
  